<mat-card>
  <h2 translate>brandMaintenance.title</h2>
  <mat-card-content>
    <p translate>brandMaintenance.subtitle</p>
    <mat-grid-list cols="16" rowHeight="90px">
      <form [formGroup]="brandForm">
        <!-- FIRST ROW -->
        <mat-grid-tile colspan="4">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>brandMaintenance.brand</mat-label>
            <input
              id="brandInputId"
              #brand
              matInput
              formControlName="brand"
              maxlength="2"
              (change)="brandForm.patchValue({ brand: $event.target.value.toUpperCase() })"
            />
          </mat-form-field>
        </mat-grid-tile>
        <!-- <mat-grid-tile colspan="4">
                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label translate>Url logo marca</mat-label>
                        <input id="logoInputId" matInput formControlName="logo" />
                    </mat-form-field>
                </mat-grid-tile> -->
        <mat-grid-tile colspan="4">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>brandMaintenance.maxBeneficiaries</mat-label>
            <input
              id="numBeneficiaryInputId"
              matInput
              formControlName="numBeneficiary"
              maxlength="2"
              autocomplete="off"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="language"
            [id]="'languageInputId'"
            [dataInput]="languageList"
            [placeholder]="'brandMaintenance.language'"
            [isRequired]="true"
            [hasToTranslateValue]="true"
            [showErrors]="brandForm?.controls?.language?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <!-- SECOND ROW -->
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="beneficiary"
            [id]="'beneficiaryInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.createBeneficiery'"
            [showErrors]="brandForm?.controls?.beneficiary?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="withShopping"
            [id]="'shoppingInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.withShopping'"
            [showErrors]="brandForm?.controls?.withShopping?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="withoutShopping"
            [id]="'noShoppingInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.noShopping'"
            [showErrors]="brandForm?.controls?.withoutShopping?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="codWorker"
            [id]="'workerInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.codEmployee'"
            [showErrors]="brandForm?.controls?.codWorker?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>

        <!-- THIRD ROW -->
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="codReference"
            [id]="'referenceInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.codReference'"
            [showErrors]="brandForm?.controls?.codReference?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="insurance"
            [id]="'insuranceInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.insurance'"
            [showErrors]="brandForm?.controls?.insurance?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="postalCode"
            [id]="'postalcodeInputId'"
            [dataInput]="optionList"
            [placeholder]="'brandMaintenance.postalCode'"
            [showErrors]="brandForm?.controls?.postalCode?.errors"
          ></scf-custom-select-search>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>brandMaintenance.discount</mat-label>
            <input id="discountInputId" matInput formControlName="discount" maxlength="2" autocomplete="off" />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="4">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>brandMaintenance.color</mat-label>
            <input id="colorInputId" matInput formControlName="color" maxlength="20" autocomplete="off" />
          </mat-form-field>
        </mat-grid-tile>
      </form>
    </mat-grid-list>
    <scf-update [isDifferentFromRequests]="true" [numFile]="0" (saveFile)="saveFile($event)"> </scf-update>
  </mat-card-content>
</mat-card>

<div class="whitelist__footer">
  <button
    id="createSolutionBtnId"
    mat-flat-button
    color="accent"
    (click)="onClickAccept()"
    [disabled]="!isAcceptEnabled"
  >
    <span>{{ 'brandMaintenance.acceptBtn' | translate | uppercase }}</span>
  </button>
  <button id="createSolutionBtnId" mat-stroked-button color="accent" (click)="onClickCancel()">
    <span>{{ 'brandMaintenance.cancelBtn' | translate | uppercase }}</span>
  </button>
</div>
